import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faUser, faSignInAlt, faSignOutAlt, faRedo, faFilter, faTimes, faSortAmountDown, faSortAmountUp, faPen, faTrash, faCheck, faMinusCircle, faReply, faUndo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCoffee, faUser, faSignInAlt, faSignOutAlt, faRedo, faFilter, faTimes, faSortAmountDown, faSortAmountUp, faPen, faTrash, faCheck, faMinusCircle, faReply, faUndo)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
